exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-container[data-v-22aa62f2] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  padding: 30px;\n}\n.icon[data-v-22aa62f2] {\n  color: #085FCE;\n}", ""]);

// exports
